<template>
    <form action="https://visualz.hu/mailer.php" class="text-black flex flex-col items-stretch justify-center"
          @submit.prevent="onSubmit">
        <div class="relative font-light mt-8 contactscroll">
            <label class="absolute pointer-events-none font-blue font-white "
                   for="name"
                   :class="{ 'focusLabel font-normal text-v-magenta': focusaa }">név</label>
            <input class="inputForm"
                   id="name"
                   type="text"
                   v-model="name"
                   @focus="focusa=true"
                   @blur="focusa=false"
                   :class="{'inputFocused':focusaa, 'hasErrors' : errors.name}">
            <span class="absolute pin-r mt-1 text-v-magenta font-normal" v-if="errors.name">Kérlek add meg a neved!</span>
        </div>
        <div class="relative font-light mt-8">
            <label class="absolute pointer-events-none"
                   for="company"
                   :class="{ 'focusLabel font-normal text-v-magenta': focusbb}">cégnév</label>
            <input class="inputForm"
                   id="company"
                   type="text"
                   v-model="company"
                   @focus="focusb=true"
                   @blur="focusb=false"
                   :class="{'inputFocused':focusbb}">
        </div>
        <div class="relative font-light mt-8">
            <label class="absolute pointer-events-none"
                   for="email"
                   :class="{ 'focusLabel font-normal text-v-magenta': focuscc}">email</label>
            <input class="inputForm"
                   id="email"
                   type="email"
                   v-model="email"
                   @focus="focusc=true"
                   @blur="focusc=false"
                   :class="{'inputFocused':focuscc, 'hasErrors' : errors.email}">
            <span class="absolute pin-r mt-2 text-v-magenta font-normal" v-if="errors.email">Érvényes email címet adj meg!</span>

        </div>
        <div class="relative font-light mt-8">
            <label class="absolute pointer-events-none"
                   for="phone"
                   :class="{ 'focusLabel font-normal text-v-magenta': focusdd}">telefonszám</label>
            <input class="inputForm"
                   id="phone"
                   type="tel"
                   v-model="phone"
                   @focus="focusd=true"
                   @blur="focusd=false"
                   :class="{'inputFocused':focusdd, 'hasErrors' : errors.phone}">
            <span class="absolute pin-r mt-2 text-v-magenta font-normal" v-if="errors.phone">Helyesen add meg a teleszonszámod!</span>

        </div>
        <div class="relative font-light mt-8">
            <label class="absolute pointer-events-none messagelabel"
                   for="message"
                   :class="{ 'focusLabel font-normal text-v-magenta': focusee}">üzeneted</label>
            <textarea rows="6"
                      class="appearance-none border-0 rounded-sm w-full my-4 py-2 px-4 resize-none"
                      id="message"
                      v-model="message"
                      @focus="focuse=true"
                      @blur="focuse=false"
                      :class="{'inputFocused':focusee, 'hasErrors' : errors.message}"></textarea>
            <span class="absolute pin-r text-v-magenta font-normal" v-if="errors.message">Hosszabb üzenetet adj meg!</span>
        </div>
        <div class="relative font-light flex flex-row mb-4 mt-8">

            <input type="checkbox" v-model="protection" class="mr-2" id="protection" :class="{'hasErrors' : errors.protection}">
            <label class="text-black font-light leading-normal text-sm" for="protection">
            Az <a @click.prevent="show" class="text-v-magenta cursor-pointer text-sm">adatvédelmi nyilatkozatot</a> elfogadom, továbbá hozzájárulok,
            hogy az adataim (név, email cím, cégnév) a VISUALZ Creative Studio adatbázisában rögzítésre kerüljenek. <br>
                <span class="text-v-magenta font-normal" v-if="errors.protection">*Kérlek fogadd el az adatvédelmi nyilatkozatot</span>
            </label>

        </div>
        <div class="my-4 flex justify-center">
            <button type="submit"
                    :class="loading ? 'loader' : ''"
                    :disabled="loading"
                    class="border-2 border-v-magenta xl:text-v-magenta hover:bg-v-magenta bg-v-magenta xl:bg-transparent text-white text-xl hover:text-white font-normal py-4 px-8 md:py-3 md:px-6 rounded-lg">
                elküldöm
            </button>
        </div>

    </form>

</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      name: '',
      email: '',
      phone: '',
      company: '',
      message: '',
      protection: false,
      errors: {
        name: false,
        email: false,
        message: false,
        phone: false,
        protection: true
      },
      focusa: false,
      focusb: false,
      focusc: false,
      focusd: false,
      focuse: false,
      loading: false
    }
  },
  methods: {
    onSubmit () {
      if (this.checkfields()) {
        this.loading = true
        axios.post('/mailer.php', {
          name: this.name,
          email: this.email,
          message: this.message,
          phone: this.phone,
          company: this.company
        })
          .then(() => {
            this.loading = false
            this.$modal.show('success')
            this.name = ''
            this.email = ''
            this.message = ''
            this.phone = ''
            this.company = ''
          })
          .catch(() => {
            this.loading = false
            this.$modal.show('error')
          })
      } else {
      }
    },
    show () {
      this.$modal.show('protection')
    },
    checkfields () {
      this.errors.name = !(this.name.length > 3)
      this.validatePhone()
      this.validateEmail()
      this.errors.message = this.message.length < 10
      this.errors.protection = !this.protection
      return (!this.errors.name && !this.errors.phone && !this.errors.email && !this.errors.protection && !this.errors.message)
    },
    validateEmail () {
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      this.errors.email = !(re.test(String(this.email).toLowerCase()))
    },
    validatePhone () {
      const regex = /^[0-9+][0-9-]+$/
      this.errors.phone = !(regex.test(this.phone) && this.phone.length > 7)
    }
  },
  computed: {
    focusaa () {
      return this.focusa || this.name !== ''
    },
    focusbb () {
      return this.focusb || this.company !== ''
    },
    focuscc () {
      return this.focusc || this.email !== ''
    },
    focusdd () {
      return this.focusd || this.phone !== ''
    },
    focusee () {
      return this.focuse || this.message !== ''
    }
  }
}
</script>

<style lang="scss" scoped>
    .inputForm, textarea {
        padding: 9px;
        border-radius: 5px;
        color: rgba(0, 0, 0, 0.7);
        transition: all .250s ease;
        position: relative;
        top: 0px;
        width: 100%;
        padding-left: 1rem;
        outline: none;
        border: 1px solid transparent;
    }
    .inputForm.hasErrors, textarea.hasErrors {
        border: 1px solid red;
    }
    button:focus {
        outline:0;
    }

    label {
        transition: all 0.15s ease-out;
        left: 16px;
        top: 10px;
        z-index: 10;
    }

    label.messagelabel {
        top: 30px
    }
    input[type=checkbox]
    {
        /* Double-sized Checkboxes */
        -ms-transform: scale(1); /* IE */
        -moz-transform: scale(1); /* FF */
        -webkit-transform: scale(1); /* Safari and Chrome */
        -o-transform: scale(1); /* Opera */
        padding: 10px;
    }
    .messagelabel.focusLabel {
        transform: translate(0, -40px);
    }

    .focusLabel {
        transform: translate(0, -30px);
    }

    input.inputFocused, textarea.inputFocused {
        box-shadow: 8px 3px 10px 0px rgba(0, 0, 0, 0.150);
    }
    // Hat-tip to Bulma.
       .loader {
           color: transparent !important;
           pointer-events: none;
           position: relative;
           background: rgb(184,31,118);
       }

    .loader:after {
        animation: spinAround 500ms infinite linear;
        border: 3px solid white;
        border-radius: 290486px;
        border-right-color: transparent;
        border-top-color: transparent;
        content: "";
        display: block;
        width: 1em;
        height: 1em;
        position: relative;
        position: absolute;
        left: calc(50% - (1em / 2));
        top: calc(50% - (1em / 2));
        position: absolute !important;
    }

    @keyframes spinAround {
        from {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/ContactForm.vue